import { useLang } from '../SubmissionV2/useLang'
import { cwdTranslations } from './translations'

export function useCwdLang() {
  const { lang, setLang } = useLang()
  return { lang, t: cwdTranslations[lang], setLang }
}
